import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { TrackingProductModel } from "@omni/types/components/tracking/models/trackingProduct.model";
import { AddToCartTrackingInfo } from "@omni/types/components/tracking/tracking-info/feature/addToCart.trackingInfo";
import { RemoveFromCartTrackingInfo } from "@omni/types/components/tracking/tracking-info/feature/removeFromCart.trackingInfo";
import { ProductImpressionTrackingInfo } from "@omni/types/components/tracking/tracking-info/impression/productImpression.trackingInfo";
import { ModelMapper } from "@omni/types/utils/modelMapper";

export const toProductImpression: ModelMapper<
    Product<ProductFieldSet.Full>,
    ProductImpressionTrackingInfo
> = (product) => {
    return {
        id: product.sku,
        ean: product.ean,
        name: product.analytics?.productTitle || product.productTitle,
        category:
            product.analytics.superCategoryCode ||
            product.analytics?.superCategoryCode,
        price: product.price?.currentPrice ?? 0,
        unitPrice: product.price?.currentPrice ?? 0,
        tax: "21%",
        reduction: `${product.price?.roundedDiscountPercentage ?? 0}%`,
        currencyCode: "EUR",
        brand: product.brand?.name ?? ""
    };
};

export const toTrackingProduct: ModelMapper<
    Product<ProductFieldSet.Full> | Product<ProductFieldSet.ProductTile>,
    TrackingProductModel
> = (product) => {
    const discountPercentage =
        product.price &&
        ("roundedDiscountPercentage" in product.price
            ? product.price.roundedDiscountPercentage
            : product.price?.discountPercentage);

    return {
        id: product.sku,
        ean: product.ean,
        name:
            product.analytics?.productTitle ||
            product.productTitle ||
            product.name ||
            "",
        category: product.analytics?.superCategoryCode || product.brand?.code,
        price: product.price?.currentPrice ?? 0,
        unitPrice: product.price?.currentPrice ?? 0,
        tax: "21%",
        reduction: `${discountPercentage ?? 0}%`,
        currencyCode: "EUR",
        brand: product.brand?.name ?? ""
    };
};

export const toAddToCartTrackingInfo: ModelMapper<
    { product: Product<ProductFieldSet.Full>; quantity: number },
    AddToCartTrackingInfo
> = ({ product, quantity }) => {
    return {
        id: product.sku,
        ean: product.ean,
        name: product.analytics?.productTitle || product.productTitle,
        category:
            product.analytics.superCategoryCode ||
            product.analytics?.superCategoryCode,
        price: product.price?.currentPrice ?? 0,
        unitPrice: product.price?.currentPrice ?? 0,
        tax: "21%",
        reduction: `${product.price?.roundedDiscountPercentage ?? 0}%`,
        currencyCode: "EUR",
        brand: product.brand?.name ?? "",
        quantity: quantity,
        url: product.url
    };
};

export const toRemoveFromCartTrackingInfo: ModelMapper<
    { product: Product<ProductFieldSet.Full>; quantity: number },
    RemoveFromCartTrackingInfo
> = ({ product, quantity }) => {
    return {
        id: product.sku,
        ean: product.ean,
        name: product.analytics?.productTitle || product.productTitle,
        category:
            product.analytics.superCategoryCode ||
            product.analytics?.superCategoryCode,
        price: product.price?.currentPrice ?? 0,
        unitPrice: product.price?.currentPrice ?? 0,
        tax: "21%",
        reduction: `${product.price?.roundedDiscountPercentage ?? 0}%`,
        currencyCode: "EUR",
        brand: product.brand?.name ?? "",
        quantity: quantity,
        url: product.url
    };
};
